import { Controller } from "@hotwired/stimulus"

/**
 * Toggles between the resource_item picker and the service_offering picker
 * inside the aggregate-distribution modal. Mirrors the canonical radio +
 * panel-show pattern (see ResourceOrders, location-type-toggle). Disables
 * the inactive panel's select so its value is excluded from the POST.
 *
 * Usage:
 *   <fieldset data-controller="distributable-toggle">
 *     <input type="radio" name="…[distributable_type]" value="resource_item"
 *            data-action="change->distributable-toggle#refresh"
 *            data-distributable-toggle-target="kind">
 *     <input type="radio" name="…[distributable_type]" value="service_offering" …>
 *     <div data-distributable-toggle-target="itemPanel">…</div>
 *     <div data-distributable-toggle-target="servicePanel">…</div>
 *   </fieldset>
 */
export default class extends Controller<HTMLElement> {
  static targets = ["kind", "itemPanel", "servicePanel", "itemSelect", "serviceSelect"]

  declare readonly kindTargets: HTMLInputElement[]
  declare readonly hasItemPanelTarget: boolean
  declare readonly itemPanelTarget: HTMLElement
  declare readonly hasServicePanelTarget: boolean
  declare readonly servicePanelTarget: HTMLElement
  declare readonly hasItemSelectTarget: boolean
  declare readonly itemSelectTarget: HTMLSelectElement
  declare readonly hasServiceSelectTarget: boolean
  declare readonly serviceSelectTarget: HTMLSelectElement

  connect() {
    this.refresh()
  }

  refresh() {
    const checked = this.kindTargets.find(radio => radio.checked)
    const kind = checked?.value || "resource_item"

    const showItem = kind === "resource_item"
    this.itemPanelTarget?.classList.toggle("hidden", !showItem)
    this.servicePanelTarget?.classList.toggle("hidden", showItem)

    if (this.hasItemSelectTarget) this.itemSelectTarget.disabled = !showItem
    if (this.hasServiceSelectTarget) this.serviceSelectTarget.disabled = showItem
  }
}
